import styles from "./SupportedControls.module.css"
import ImgEnjoyableKeyboard from "@/assets/img/Icon_Keyboard_Mouse.svg"
import ImgEnjoyableGamepad from "@/assets/img/Icon_Games.svg"
import ImgEnjoyableTouchscreen from "@/assets/img/Icon_Touchscreen.svg"

interface SupportedControlsProps extends React.ComponentProps<"div"> {
  type: number
}

const KEYBOARD = 1
const TOUCHSCREEN = 2
const GAMEPAD = 4

export default function SupportedControls({ type, ...rest }: SupportedControlsProps) {
  return (
    <div className={styles.main} {...rest} data-testid="SupportedControls_type">
      {type & KEYBOARD ? <ImgEnjoyableKeyboard /> : null}
      {type & GAMEPAD ? <ImgEnjoyableGamepad /> : null}
      {type & TOUCHSCREEN ? <ImgEnjoyableTouchscreen /> : null}
    </div>
  )
}